<template>
  <div class="heng">
    <div class="header">
      <div style="display:flex;align-items: center;">
        <img src="@/assets/house/breadicon.png"
             style="margin-right:10px"
             alt />
        <el-breadcrumb separator="/">
          <!-- <el-breadcrumb-item>工作桌面</el-breadcrumb-item> -->
          <el-breadcrumb-item>平台运维</el-breadcrumb-item>
          <el-breadcrumb-item>运维操作</el-breadcrumb-item>
          <!-- <el-breadcrumb-item>活动详情</el-breadcrumb-item> -->
        </el-breadcrumb>
      </div>
      <div class="refresh">
        <img :class="isRefresh ?'imgmove':''"
             width="16px"
             height="16px"
             src="@/assets/house/refresh.png"
             alt />
        <p>刷新</p>
      </div>
    </div>

    <div class="main">
      <div class="head">
        <h4>运维操作</h4>
      </div>

      <div class="kabj">
        <div v-for="(e,index) in platformList"
             :key="index"
             :class="isSimple ? 'ka simpleka' : 'ka'"
             @click="operation(e)">
          <img width="103"
               height="103"
               :src="e.src"
               alt="">
          <div class="text">
            <p>{{e.title}}</p>
            <p style="margin-top: 20px;">{{e.text}}</p>
          </div>
        </div>
      </div>

    </div>








    <el-dialog
        :visible.sync="dialogVisible"
        width="26%"
        :before-close="handleClose">
      <div slot="title" class="header-title" :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>平台运维操作</div>
      </div>
      <div style="margin:10px 0;color:red;">您正在进行高危操作，请在下方的输入框中输入：<span style="font-weight:bolder;font-size:18px;">{{psw}}</span></div>
      <el-input v-model="password" placeholder="请输入验证码"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button v-if="!isClick" :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}" type="primary" @click="beSure">确 定</el-button>
        <el-button v-else :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}" type="primary" disabled>确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { getDate, formatConversion } from "@/plugins/getdate";
import { generateAllThumb,generateAllPeopleFaceDiff,generateAllPeopleFace,generateAllFileLabels,generateAllUserNas,restartNasServer,flushUserPowers,flushLog,flushCache,everyoneOffline,fullSearchDataSync } from "@/api/system"
import { delHalfPackage } from "@/api/picturePackage";


export default {

  data () {
    return {
      isClick:false,

      
      isRefresh: false,
      dialogVisible: false,
      password:'',
      psw:'',
      title:'',
      platformList: [
        {
          title: '清除缓存',
          text: '点击此按钮可以清除当前平台中所有的缓存以便显示最新数据。请勿频繁使用此功能。',
          src: require('@/assets/platform/1.png')
        },
        {
          title: '所有用户下线',
          text: '你可以通过此功能让当前所有用户下线，仅适合在紧急情况下使用。',
          src: require('@/assets/platform/2.png')
        },
        {
          title: '清除所有用户权限缓存',
          text: '当删除或修改某些角色之后，所关联的用户未能正确刷新权限，导致出现错误，可通过本功能进行处理。',
          src: require('@/assets/platform/4.png')
        },
        {
          title: '重新生成共享盘账户',
          text: '某些用户可能因为意外因素导致未能正确生成共享盘账户，可通过此功能重新生成共享盘账户。',
          src: require('@/assets/platform/3.png')
        },
        {
          title: '重新启动共享盘服务',
          text: '新增用户需要立刻使用共享盘，可以通过此操作重启共享盘服务，但也会导致其他正在使用的用户异常掉线。',
          src: require('@/assets/platform/5.png')
        },
        {
          title: '清除所有系统日志',
          text: '清除所有系统日志，防止日志数据量过大导致系统运行缓慢。',
          src: require('@/assets/platform/6.png')
        },
        {
          title: '批量重新生成图片标签',
          text: '用来重置图片标签的，所以会很慢，看具体的图片数量，执行完毕后需要等待很久。',
          src: require('@/assets/platform/9.png')
        },
        {
          title: '批量重新生成人脸',
          text: '用来重置图片中的人脸信息的，所以会很慢，看具体的图片数量，执行完毕后需要等待很久。',
          src: require('@/assets/platform/10.png')
        },
        {
          title: '检索数据全量同步',
          text: '用来立刻触发重建检索信息库动作，搜索功能将短暂不可用，看数据量大小，大约3-20分钟后恢复。',
          src: require('@/assets/platform/13.png')
        },
        {
          title: '重新比对人脸记录',
          text: '用来重新比对人脸对应人物关系的，所以会很慢，看具体的人脸数量、人物数量，通常在5-30分钟内结束。',
          src: require('@/assets/platform/14.png')
        },
        {
          title: '重新生成失败缩略图',
          text: '对之前缩略图生成失败的图片重新生成缩略图，看具体的图片数量，执行完毕后需要等待很久。',
          src: require('@/assets/platform/15.png')
        },
        {
          title: '一键清除下载压缩包',
          text: '由于生成的下载压缩包较多，会挤占掉原本的磁盘空间，此操作会将超过半年的压缩文件清空，释放内存空间。',
          src: require('@/assets/platform/1.png')
        }
      ]
    };
  },
  methods: {
    handleClose(){
      this.dialogVisible = false
      this.password = ''
    },
    rand(min,max) {
        return Math.floor(Math.random()*(max-min))+min;
    },
    operation (e) {
      this.title = e.title
      var randnum = this.rand(1000,9999);
      this.psw = randnum
      this.dialogVisible = true
      // this.$confirm('确定' + e.title + '吗?', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // }).then(() => {
      //   if (e.title == "重新生成共享盘账户") {
      //     this.generateAllUserNasAsync()
      //   }
      // })
    },

    beSure(){
      if(this.password == this.psw){
        this.isClick = true
        setTimeout(() => {
          this.isClick = false
        }, 2000);
        if(this.title == "重新生成共享盘账户"){
          let val = {
            foolProofingCheck:'#foolProofingCode#'
          }
          this.generateAllUserNasAsync(val)
        }else if(this.title == "清除缓存"){
          let val = {
            foolProofingCheck:'#foolProofingCode#'
          }
          this.flushCacheAsync(val)
        }else if(this.title == "重新启动共享盘服务"){
          let val = {
            foolProofingCheck:'#foolProofingCode#'
          }
          this.restartNasServerAsync(val)
        }else if(this.title == "清除所有用户权限缓存"){
          let val = {
            foolProofingCheck:'#foolProofingCode#'
          }
          this.flushUserPowersAsync(val)
        }else if(this.title == "所有用户下线"){
          let val = {
            foolProofingCheck:'#foolProofingCode#'
          }
          this.everyoneOfflineAsync(val)
        }else if(this.title == "清除所有系统日志"){
          let val = {
            foolProofingCheck:'#foolProofingCode#'
          }
          this.flushLogAsync(val)
        }else if(this.title == "批量重新生成图片标签"){
          let val = {
            foolProofingCheck:'#foolProofingCode#'
          }
          this.generateAllFileLabelsAsync(val)
        }else if(this.title == "批量重新生成人脸"){
          let val = {
            foolProofingCheck:'#foolProofingCode#'
          }
          this.generateAllPeopleFaceAsync(val)
        }else if(this.title == "检索数据全量同步"){
          let val = {
            foolProofingCheck:'#foolProofingCode#'
          }
          this.fullSearchDataSyncAsync(val)
        }else if(this.title == "重新比对人脸记录"){
          let val = {
            foolProofingCheck:'#foolProofingCode#'
          }
          this.generateAllPeopleFaceDiffAsync(val)
        }else if(this.title == "重新生成失败缩略图"){
          let val = {
            foolProofingCheck:'#foolProofingCode#'
          }
          this.generateAllThumbAsync(val)
        }else if(this.title == "一键清除下载压缩包"){
          // let val = {
          //   foolProofingCheck:'#foolProofingCode#'
          // }
          this.delHalfPackageAsync()
        }


        
        this.handleClose()
      }else{
        this.$message.warning('请输入正确的验证码！')
      }
    },
    // 一键清除超过半年的压缩包
    async delHalfPackageAsync() {
      let { status, data, message,errors } = await delHalfPackage();
      if (status) {
        this.$message.success(message)
      }else{
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },


    //重新生成失败缩略图
    async generateAllThumbAsync (val) {
      let { status, data, message,errors } = await generateAllThumb(val);
      if (status) {
        this.$message.success(message)
      }else{
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //重新比对人脸记录
    async generateAllPeopleFaceDiffAsync (val) {
      let { status, data, message,errors } = await generateAllPeopleFaceDiff(val);
      if (status) {
        this.$message.success(message)
      }else{
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //检索数据全量同步
    async fullSearchDataSyncAsync (val) {
      let { status, data, message,errors } = await fullSearchDataSync(val);
      if (status) {
        this.$message.success(message)
      }else{
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },
    //批量重新生成人脸
    async generateAllPeopleFaceAsync (val) {
      let { status, data, message,errors } = await generateAllPeopleFace(val);
      if (status) {
        this.$message.success(message)
      }else{
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //批量重新生成图片标签
    async generateAllFileLabelsAsync (val) {
      let { status, data, message,errors } = await generateAllFileLabels(val);
      if (status) {
        this.$message.success(message)
      }else{
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //生成所有用户网盘列表
    async generateAllUserNasAsync (val) {
      let { status, data, message,errors } = await generateAllUserNas(val);
      if (status) {
        this.$message.success(message)
      }else{
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //重启网盘服务
    async restartNasServerAsync (val) {
      let { status, data, message,errors } = await restartNasServer(val);
      if (status) {
        this.$message.success(message)
      }else{
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //清除所有用户权限缓存
    async flushUserPowersAsync (val) {
      let { status, data, message,errors } = await flushUserPowers(val);
      if (status) {
        this.$message.success(message)
      }else{
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //清除所有日志
    async flushLogAsync (val) {
      let { status, data, message,errors } = await flushLog(val);
      if (status) {
        this.$message.success(message)
      }else{
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //清除所有缓存
    async flushCacheAsync (val) {
      let { status, data, message,errors } = await flushCache(val);
      if (status) {
        this.$message.success(message)
      }else{
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //所有用户立刻下载
    async everyoneOfflineAsync (val) {
      let { status, data, message,errors } = await everyoneOffline(val);
      if (status) {
        this.$message.success(message)
      }else{
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },
  },
  created () {
    if(this.isSimple){
      this.platformList.splice(6,2)
    }
  },
  beforeDestroy () {

  },
  mounted () { }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./platform.scss";
@import "@/constants/elHeader.scss";
h4 {
  font-size: 18px;
}
</style>
